import { ObjectHash } from '../../types/shared'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const decodeQueryString = <T extends ObjectHash<string, string> = ObjectHash<string, string>>(...args): T =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.FLibs.decodeQueryString(...args)

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const encodeQueryString = (...args) => window.FLibs.encodeQueryString(...args)
